import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      padding: theme.spacing(1),
      justifyContent: "center",

      "& h2": {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,

        [theme.breakpoints.up("md")]: {
          fontSize: theme.typography.pxToRem(22),
        },
      },
    },

    questionsContainer: {
      marginTop: theme.spacing(2),
      justifyContent: "center",
    },
    questionButton: {
      padding: theme.spacing(0.5, 1.5),
      textTransform: "initial",
      borderRadius: 18,
    },
    activeQuestion: {
      color: theme.palette.primary.contrastText,
      background: "#00B5EE",
      border: `1px solid ${theme.palette.primary.light}`,

      "&:hover": {
        background: "#00B5EE",
      },
    },

    buttonsContainer: {
      marginTop: theme.spacing(6),
      alignItems: "center",
    },
    backButton: {
      padding: theme.spacing(0.5, 3),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "initial",
      borderRadius: 17,
    },
    forwardButton: {
      marginTop: 0,
    },
  })
);

export default useStyles;
